<parkour-profiel-details-card
  icon="badge-on"
  title="Geverifieerd professioneel profiel"
  backgroundColor="bg-n-300"
>
</parkour-profiel-details-card>
